import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonColor, injectEnvironment } from '@cf/core';
import { ButtonComponent } from '@cf/shared/ui/button';
import { IconComponent } from '@cf/shared/ui/icons';
import { AuthService } from '@cf/temp/services';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'cf-microsoft-auth',
  templateUrl: './microsoft-auth.component.html',
  styleUrl: './microsoft-auth.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, IconComponent],
})
export class MicrosoftAuthComponent {
  @Input() invitationEmail!: string | undefined;
  @Input() color: ButtonColor = 'primary-dark';
  @Input() redirectUriKey?: string;
  @Input() redirectToSignUp = false;
  private environment = injectEnvironment();

  constructor(
    private readonly authService: AuthService,
    private readonly cookieService: CookieService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
  ) {}

  signUp() {
    if (this.redirectToSignUp) {
      window.open(`${this.environment.appUrl}/auth/sign-up`, '_self');
      return;
    }
    if (this.redirectUriKey) {
      this.cookieService.set(
        'redirection_url_ms_booking',
        this.router.url,
        new Date().setMinutes(30),
        '/',
      );
    }
    this.cookieService.delete('flow_key', '/');
    this.authService.microsoft(this.redirectUriKey).subscribe((res: any) => {
      this.cookieService.set('flow_key', res.flow_key, new Date().setMinutes(30), '/');
      this.cookieService.set(
        'ms_redirect_params',
        JSON.stringify({
          invitationEmail: this.invitationEmail,
          ...this.route.snapshot.queryParams,
        }),
        new Date().setMinutes(30),
        '/',
      );
      window.open(res.auth_uri, '_self');
    });
  }
}
